import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import config from '~/config';

const ToastPhotoDownloading = withI18next()(({ t }) => {
  return (
    <div>
      <img
        src={`${config.staticPrefix}/static/assets/image/download-pages/download.svg`}
        height="20"
        alt="icon download"
        style={{ marginRight: 8 }}
      />
      {t('photo_downloading_notification')}
    </div>
  );
});

export default ToastPhotoDownloading;
